import type { FC } from "react";

import { Button, Row, Spinner, Text, Tooltip } from "@hightouch/htui";

type Props = {
  columnName: string;
  total: number | null;
  isLoading: boolean;
  isUnavailable: boolean;
  onOpen: (columnName: string) => void;
};

export const ColumnUsageSpinner: FC = () => (
  <Row align="center" justify="center" width="40px">
    <Spinner size="sm" aria-label="Calculating usage" />
  </Row>
);

export const ColumnUsageCell: FC<Props> = ({
  columnName,
  total,
  isLoading,
  isUnavailable,
  onOpen,
}) => {
  if (isLoading) {
    return <ColumnUsageSpinner />;
  }

  if (isUnavailable || total === null) {
    return (
      <Tooltip message="Usage is unavailable">
        <Text color="text.secondary">—</Text>
      </Tooltip>
    );
  }

  return (
    <Button size="sm" variant="tertiary" onClick={() => onOpen(columnName)}>
      {total.toLocaleString()}
    </Button>
  );
};
